module.exports = __webpack_public_path__ + "img/Indicator.8fdf19f3.png";